import styled from 'styled-components';

import {LoadingSpinner} from '@yourcoach/shared/uikit/LoadingSpinner';
import {View} from '@yourcoach/shared/uikit/View';

const Container = styled(View)`
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const SpinnerFallback = () => {
  return (
    <Container>
      <LoadingSpinner size={50} />
    </Container>
  );
};
